module.exports = __webpack_public_path__ + "static/PrimitiveTen-47576b2b2e68014c1bbc58d4dd0f272c.png";